import React from 'react'
import ImageNotSupportedOutlinedIcon from '@mui/icons-material/ImageNotSupportedOutlined'
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline'
import { Box, CardActionArea, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import type { TrainingVideo } from '../../types/Training/TrainingVideo'

type TutorialListItemProps = {
	tutorial: TrainingVideo
	onClick: (tutorial: TrainingVideo) => void
}

const TutorialListItem = ({ tutorial, onClick }: TutorialListItemProps) => {
	const [thumbnailLoadFailed, setThumbnailLoadFailed] = useState(false)

	return (
		<CardActionArea
			onClick={() => onClick(tutorial)}
			sx={{
				borderRadius: 1.5,
				border: '1px solid',
				borderColor: 'divider',
				backgroundColor: 'grey.100',
				p: 1,
				transition: 'background-color 0.2s ease, border-color 0.2s ease',
				'&:hover': {
					backgroundColor: 'grey.200',
					borderColor: 'primary.dark',
				},
			}}
			aria-label={`Open tutorial: ${tutorial.title}`}
		>
			<Stack direction='row' spacing={1.25} alignItems='flex-start'>
				<Box
					sx={{
						width: 96,
						height: 80,
						borderRadius: 1,
						backgroundColor: 'grey.100',
						overflow: 'hidden',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						flexShrink: 0,
					}}
				>
					{!thumbnailLoadFailed ? (
						<Box
							component='img'
							src={`${tutorial.thumbnailUri}?${tutorial.thumbnailSasToken}`}
							alt={`${tutorial.title} thumbnail`}
							onError={() => setThumbnailLoadFailed(true)}
							sx={{
								width: '100%',
								height: '100%',
								objectFit: 'cover',
								objectPosition: 'left top',
								transform: 'scale(1.1)',
								transformOrigin: 'left top',
							}}
						/>
					) : (
						<ImageNotSupportedOutlinedIcon color='disabled' />
					)}
				</Box>
				<Stack spacing={0.5} minWidth={0} flex={1}>
					<Typography variant='subtitle2' noWrap title={tutorial.title} color='text.primary' fontWeight={600}>
						{tutorial.title}
					</Typography>
					<Typography
						variant='body2'
						color='text.primary'
						sx={{
							display: '-webkit-box',
							WebkitLineClamp: 2,
							WebkitBoxOrient: 'vertical',
							overflow: 'hidden',
							opacity: 0.8,
						}}
						title={tutorial.description}
					>
						{tutorial.description}
					</Typography>
					<Stack direction='row' spacing={1} alignItems='center'>
						<PlayCircleOutlineIcon sx={{ fontSize: 14 }} color='primary' />
						<Typography variant='caption' color='primary.main' fontWeight={500}>
							Watch
						</Typography>
					</Stack>
				</Stack>
			</Stack>
		</CardActionArea>
	)
}

export default TutorialListItem
